import { createFileRoute } from '@tanstack/react-router'

import { MatchesPage } from '~/features/football-matches/matches-page'
import { matchesQueryOptions } from '~/features/football-matches/query-options'
import { parseMatchesSearch, resolveMatchesSearch } from '~/features/football-matches/search-schema'
import { seo } from '~/utils/seo'
import { getPageMeta } from '~/utils/seo-meta'

export const Route = createFileRoute('/_public/matches')({
  validateSearch: parseMatchesSearch,
  head: () => seo({
    ...getPageMeta('/matches', 'en'),
    pathname: '/matches',
    locale: 'en',
  }),
  loaderDeps: ({ search }) => resolveMatchesSearch(search),
  loader: async ({ context, deps }) => {
    await context.queryClient.prefetchQuery(matchesQueryOptions(deps))
  },
  component: MatchesRoute,
})

function MatchesRoute() {
  return <MatchesPage search={Route.useSearch()} />
}
